import { Star, Quote } from "lucide-react";
import { Reveal, SectionLabel } from "./Reveal";
import { TESTIMONIALS } from "../data/clinic";

const Stars = () => (
  <div className="flex gap-1" aria-label="5 out of 5 stars">
    {Array.from({ length: 5 }).map((_, i) => (
      <Star key={i} className="w-4 h-4 fill-sa-bronze text-sa-bronze" />
    ))}
  </div>
);

export const Testimonials = () => (
  <section
    id="reviews"
    data-testid="testimonials-section"
    className="py-24 sm:py-32 bg-sa-espresso"
  >
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-16">
        <div>
          <Reveal>
            <div className="flex items-center gap-3">
              <span className="h-px w-8 bg-sa-bronze" />
              <span className="font-body text-xs sm:text-sm uppercase tracking-[0.22em] font-semibold text-sa-bronze">
                Patient testimonials
              </span>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-display font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-sa-cream mt-6">
              Loved by pet owners
              <span className="italic text-sa-bronze"> across Islamabad</span>
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.15}>
          <div className="flex items-center gap-4" data-testid="rating-summary">
            <div>
              <Stars />
              <p className="font-body text-sm text-sa-cream/60 mt-1.5">
                5-star rated for compassionate care
              </p>
            </div>
          </div>
        </Reveal>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={i} delay={i * 0.12}>
            <figure
              data-testid={`testimonial-${i}`}
              className="h-full bg-sa-cream/[0.04] border border-sa-cream/10 rounded-[32px] p-8 sm:p-10 flex flex-col"
            >
              <Quote className="w-9 h-9 text-sa-bronze mb-6" />
              <blockquote className="font-display font-light text-lg sm:text-xl leading-relaxed text-sa-cream/90 flex-1">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-8 flex items-center justify-between">
                <div>
                  <p className="font-body font-semibold text-sa-cream">
                    {t.name}
                  </p>
                  <p className="font-body text-sm text-sa-cream/50">
                    — {t.source}
                  </p>
                </div>
                <Stars />
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Testimonials;
